// listens for iFrame height messages from the pardot external form
// updates the height of the iframe to match the height of the form
const onMessageSend = (e) => {
  // TODO: Add QA url and remove localhost after development
  // and only manually add it when needed
  const allowedOrigins = [
    'https://www.syniverse.com',
    'https://syniverse.com',
    'https://info.syniverse.com',
    'https://qa.fictive-syniverse.net',
  ];

  if (!allowedOrigins.includes(e.origin)) {
    return;
  }

  const iframes = document.querySelectorAll('[data-ref="pardot-iframe"]');

  iframes.forEach((iframeEl) => {
    const {event, data} = e.data;

    // if (iframeEl.src == data.id) {
    switch (event) {
    case 'setHeight':
      iframeEl.style.height = `${data.height}px`;
      break;
    }
    // }
  });
};

const init = () => {
  window.addEventListener('message', onMessageSend);
};

init();
